import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum PurposeOfStayId {
  LEISURE = 1,
  BUSINESS = 2,
  OTHER = 3,
}

export class PurposeOfStay extends Codebook<PurposeOfStayId> {
  private constructor(
    public readonly id: PurposeOfStayId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  static readonly LEISURE = new PurposeOfStay(PurposeOfStayId.LEISURE, () => $t('Leisure'))
  static readonly BUSINESS = new PurposeOfStay(PurposeOfStayId.BUSINESS, () => $t('Business trip'))
  static readonly OTHER = new PurposeOfStay(PurposeOfStayId.OTHER, () => $t('Other / Different'))
}
